import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { vehicleNumberDisplay,numberFormat } from '../../../../utils/utils';
import { Box } from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    height: 72,
    padding: "14px 16px",
    display: 'flex',
    alignItems: 'center',
    backgroundColor:'#fff',
    justifyContent:'space-between',
    borderRadius: 8,
    border: 'solid 1px #ddd',
    boxShadow:'none'
  },
  icon:{
    fontSize:52,
    color:'#000'
  },
  label:{
    color:'#636872',
    fontSize:12,
    marginBottom:2
  },
  partyName:{
    fontWeight:600,
    color:'#03c',
    fontSize:16,
    cursor:'pointer'
  },
  balance:{
    fontWeight:600,
    color:'#008556',
    fontSize:16
  }
}));
const JourneySupplierCard = (props) => {
  const {supplier,amount} = props;
  const classes = useStyles();
  let history = useHistory();
  const goToSupplierView = (index) => {
    if (supplier && supplier.vendorId) {
      let vendorId = supplier.vendorId;
      let vendorName = supplier.vendorName;
      history.push({
        pathname: `/suppliers/single-supplier/trips/${vendorId}`,
        state: {
          id: 8,
          pageTitle: vendorName ? vendorName : 'Vendor View',
          vendorId: vendorId
        }
      });
    }
  }
  return (
    <>
      <Paper component='div' className={classes.card} >
          <div>
            <Typography className={classes.label}>Supplier Name</Typography>
            <Typography className={classes.partyName} onClick={goToSupplierView}>{supplier && supplier.vendorName? supplier.vendorName:''}</Typography>
          </div>
          <div>
            <Typography className={classes.label}>Supplier Balance</Typography>
            <Typography className={classes.balance}>{numberFormat(supplier && supplier.vendorBalance?supplier.vendorBalance:0)}</Typography>
          </div>
      </Paper>
    </>
  );
}
export default JourneySupplierCard;